import { updateWebhook } from "../mutations/updateWebhook.pim.js";
import { getAllWebhooks } from "../queries/getAllWebhooks.pim.js";
import { WEBHOOK_URL_UTV_ROUTING } from "../utv-routes.js";
import Logger from "@cappelendamm/logger";
const UTV_TENANT_ID = process.env.UTV_TENANT_ID;
export const setWebhooksToUrl = async (client, tenantToUpdate) => {
    let tenantId;
    let webhookRoutes;
    if (tenantToUpdate === "cada-netthandel-utv") {
        tenantId = UTV_TENANT_ID;
        webhookRoutes = WEBHOOK_URL_UTV_ROUTING;
    }
    if (!tenantId || !webhookRoutes) {
        return {
            success: false,
            message: `No tenantId or webhookRoutes found for tenant: ${tenantToUpdate}`,
        };
    }
    const allWebhooks = await getAllWebhooks({ tenantId }, { client });
    if (!allWebhooks)
        return {
            success: false,
            message: `No webhooks found in ${tenantId}`,
        };
    let updatedWebhooksCount = 0;
    for (const webhook of allWebhooks) {
        try {
            const matchingWebhook = webhookRoutes.find((value) => value.name === webhook.name);
            const input = {
                url: matchingWebhook?.url ||
                    "[INVALID URL DUE TO WEBHOOK NOT FOUND IN LIST]",
            };
            if (matchingWebhook?.headers)
                input.headers = matchingWebhook.headers;
            const id = await updateWebhook({ id: webhook.id, input }, { client });
            if (id && matchingWebhook)
                updatedWebhooksCount++;
        }
        catch (e) {
            Logger.error(`Failed to overwrite webhook: ${webhook.name} in tenant: ${tenantId}.`, e);
        }
    }
    if (updatedWebhooksCount !== allWebhooks.length) {
        return {
            success: false,
            message: `Only ${updatedWebhooksCount} of ${allWebhooks.length} webhooks updated in ${tenantId}`,
        };
    }
    return {
        success: true,
        message: `${updatedWebhooksCount} webhooks updated in ${tenantId}`,
    };
};
